// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "th.is-subtotal[data-v-df3ae0b4] {\n  width: 7em;\n}\n.subtext[data-v-df3ae0b4] {\n  font-size: 10px;\n}\n.no-border td[data-v-df3ae0b4],\n.no-border th[data-v-df3ae0b4] {\n  border: none;\n}\n.has-bottom-border-only td[data-v-df3ae0b4] {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n.no-border-last-row tr:last-child td[data-v-df3ae0b4] {\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
